/// <amd-module name="Test/TestResultsMenu/Services/TestResultsMenuService" />
import * as React from "react";

import { IVssLayoutManager } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";
import { Services, VssService } from "VSS/Platform/Context";
import { ITestResultTreeData } from "Test/common-util/Contracts/ViewContracts";
import { IViewContextData } from "Test/common-util/Common";

export interface ITestResultsMenuService {
    addWorkItem(key: string, results: ITestResultTreeData[], context: IViewContextData): void;
}

class TestResultsMenuService extends VssService implements ITestResultsMenuService {
    public addWorkItem(key: string, results: ITestResultTreeData[], context: IViewContextData): void {        
            const layoutManager = this.pageContext.getService<IVssLayoutManager>("IVssLayoutManager");
            layoutManager.renderCallout(() => {
                return React.createElement(LegacyComponent, {
                    modules: ["TestManagement/Scripts/Scenarios/TestTabExtension/Components/LegacyBugDialog"],
                    wrappedType: "legacyBugDialog",
                    dialogType: key,
                    results: results,
                    viewContext: context
                }, null);
            });
    }
}

Services.add("test-results-menu-service", { serviceFactory: TestResultsMenuService });
